import React from 'react';
import ReactDOM from 'react-dom';

import * as config from './config';

import globalActions from './actions/global-actions';
import List from './components/list';
import renderMap from './map';
import {updateStateFromLocation, updateUrl} from './history';

renderMap(config);

ReactDOM.render(<List />, document.getElementById('bssp-list-container'));

process.nextTick(() => globalActions.sync());

let lastStandId = null;
globalActions.selectStand.listen((standId) => {
	if (standId !== lastStandId) {
		lastStandId = standId;
		updateUrl(standId);
	}

	if (!standId) {
		// stand details are set in effect by details component
		document
			.querySelector('meta[property=og\\:title]')
			.setAttribute(
				'content',
				'Standplan - Weihnachtsmarkt Braunschweig'
			);
		document
			.querySelector('meta[property=og\\:description]')
			.setAttribute(
				'content',
				'Stände und Besonderheiten auf dem Braunschweiger Weihnachtsmarkt 2024'
			);
		document
			.querySelector('meta[property=og\\:url]')
			.setAttribute(
				'content',
				'https://www.braunschweig.de/apps/standplan/?mtm_campaign=wm24&mtm_source=og'
			);
		document
			.querySelector('meta[property=og\\:image]')
			.setAttribute(
				'content',
				'https://www.braunschweig.de/apps/standplan/assets/og.jpg'
			);
		document
			.querySelector('link[rel=canonical]')
			.setAttribute(
				'href',
				'https://www.braunschweig.de/apps/standplan/'
			);
	}
});

window.addEventListener('popstate', () => {
	updateStateFromLocation();
});

if (window.parent && window.parent !== window) {
	window.parent.addEventListener('popstate', () => {
		updateStateFromLocation(window.parent.document.location);
	});
}

if ('serviceWorker' in navigator) {
	navigator.serviceWorker
		.register('/apps/standplan/sw.js?v=' + config.assetVersion, {
			scope: '/apps/standplan/',
		})
		.then(
			(registration) => {
				console.log(
					'Service worker registration succeeded:',
					registration
				);
			},
			(error) => {
				console.error(`Service worker registration failed: ${error}`);
			}
		);
} else {
	console.error('Service workers are not supported.');
}
